import { registerCtaClickListener } from './app/_shared/telemetry/ctaClickListener';
import { parseDeploymentId } from './instrumentation-client/parseDeploymentId';
import { withDeploymentIdHeader } from './instrumentation-client/withDeploymentIdHeader';

/**
 * This file is compiled at build time and distributed with Next's static assets.
 * It is loaded in the browser before the rest of the client application javascript.
 * "process.env" here references the build environment within CircleCI.
 * Next/WebPack hard code the value of "NEXT_DEPLOYMENT_ID" at build time.
 */
const deploymentId = parseDeploymentId(process.env.NEXT_DEPLOYMENT_ID);

if (deploymentId !== null) {
    window.fetch = withDeploymentIdHeader(window.fetch, deploymentId, window.location);
}

registerCtaClickListener();
